import type { TSong, TDraftReviewSong } from '@modules/types'
import { isPrintOnly, isDigitalOnly, isBoth } from '@modules/api-core'

export const getDisplayPrice = (
  feeQuotedPriceValue: string,
  draftReviewSong: TDraftReviewSong | undefined,
  song: TSong,
  distributionMethod: number,
  feeType: 'print' | 'digital',
): number => {
  if (feeQuotedPriceValue) {
    return Number(feeQuotedPriceValue)
  }

  if (
    feeType === 'print' &&
    draftReviewSong?.printIsCounterOffered &&
    draftReviewSong?.printCounterOfferFee !== undefined
  ) {
    return draftReviewSong.printCounterOfferFee
  }

  if (
    feeType === 'digital' &&
    draftReviewSong?.digitalIsCounterOffered &&
    draftReviewSong?.digitalCounterOfferFee !== undefined
  ) {
    return draftReviewSong.digitalCounterOfferFee
  }

  if (isPrintOnly(distributionMethod)) {
    return song.printPublisherFee || 0
  }
  if (isDigitalOnly(distributionMethod)) {
    return song.digitalPublisherFee || 0
  }
  if (isBoth(distributionMethod)) {
    return feeType === 'digital' ? song.digitalPublisherFee || 0 : song.printPublisherFee || 0
  }

  return song.digitalPublisherFee || 0
}

export const getCounterOfferInfo = (
  song: TSong,
  feeType: 'print' | 'digital',
): { initialFee: number; proposedFee: number; currencyId: number } | null => {
  if (!song.counterOfferFees || song.counterOfferFees.length === 0) {
    return null
  }

  const counterOfferType = feeType === 'print' ? 1 : 2

  const counterOffer = song.counterOfferFees.find(
    offer => offer.counterOfferType === counterOfferType || offer.counterOfferType === 3,
  )

  if (!counterOffer) {
    return null
  }

  return {
    initialFee: counterOffer.initialFee,
    proposedFee: counterOffer.proposedFee,
    currencyId: counterOffer.currencyId,
  }
}
